{
  "completed": "Dokončeno: ",
  "current": "Aktuální: ",
  "notCompleted": "Nedokončeno: ",
  "steplist": "Seznam kroků"
}
